export enum LoginType {
  Password = 'password',
  Otp = 'otp',
}
